import React from 'react';

export default function Backdrop({ onClick }) {
    return <div className="backdrop" onClick={onClick} />;
}
